import { render, staticRenderFns } from "./frontEnd.vue?vue&type=template&id=6bf67579&"
import script from "./frontEnd.vue?vue&type=script&lang=js&"
export * from "./frontEnd.vue?vue&type=script&lang=js&"
import style0 from "./frontEnd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "frontEnd.vue"
export default component.exports